import React from "react";
import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";

import {
  Box,
  Container,
  Flex,
  Link,
  Stack,
  Text,
  Heading,
} from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="#08090C"
      color="white"
      borderTop="1px solid rgba(255,255,255,0.08)"
      mt="auto"
    >
      <Container maxW="1200px" py={{ base: 8, md: 10 }}>
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "flex-start", md: "center" }}
          gap={8}
        >
          {/* LEFT SIDE */}
          <Stack spacing={2}>
            <Heading
              fontFamily="'Rajdhani', sans-serif"
              fontSize="2xl"
              textTransform="uppercase"
              letterSpacing="0.08em"
            >
              764 Entertainment
            </Heading>

            <Text color="gray.400" fontSize="sm" maxW="420px">
              Developer of Velocity Protocol, a fast-paced movement-shooter
              roguelike built around speed, momentum, and aggressive sci-fi
              combat.
            </Text>
          </Stack>

          {/* RIGHT SIDE LINKS */}
          <Stack
            spacing={3}
            align={{ base: "flex-start", md: "flex-end" }}
            fontSize="sm"
          >
            <Flex
              gap={5}
              wrap="wrap"
              justify={{ base: "flex-start", md: "flex-end" }}
            >
              <Link href="/" color="gray.400" _hover={{ color: "white" }}>
                Home
              </Link>

              <Link
                href="/leaderboard"
                color="gray.400"
                _hover={{ color: "white" }}
              >
                Leaderboard
              </Link>

              <Link
                href="/press"
                color="gray.400"
                _hover={{ color: "white" }}
              >
                Press Kit
              </Link>

              <Link
                href="/feedback"
                color="gray.400"
                _hover={{ color: "white" }}
              >
                Feedback
              </Link>

              <Link
                href="https://764entertainment.com"
                isExternal
                color="gray.400"
                _hover={{ color: "white" }}
              >
                764 Entertainment
              </Link>

              <Link
                href="https://www.youtube.com/@764Entertainment"
                isExternal
                color="gray.400"
                _hover={{ color: "white" }}
              >
                YouTube
              </Link>
            </Flex>

            <Link
              href="mailto:hello@764entertainment.com"
              color="cyan.300"
              _hover={{ color: "cyan.200" }}
            >
              hello@764entertainment.com
            </Link>

            <Text color="gray.500" fontSize="xs">
              &copy; {new Date().getFullYear()} 764 Entertainment. All rights
              reserved.
            </Text>
          </Stack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
